export default __webpack_public_path__ + "static/media/eton-1.49b10cd1.gif";